import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/partner-api/webhooks/$id')({
  component: () => null,
});
